import React, { Component } from 'react';
import CompanyItemCard from 'containers/CompanyContainer/CompanyItemCard';
import { withRouter } from 'react-router-dom';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';
import styled, {css} from 'styled-components'
import PropTypes from 'prop-types';
import StaffCardContainer from 'containers/CompanyContainer/StaffCardContainer';

const GeneralCardWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
`
const ContainerWrapper = styled.div`
    padding: 3% 8% 4% 8%;
`
const TitleWrapper = styled.h3`
    font-size: 30px;
    font-weight: 400;
    letter-spacing: 0.5px;
    color: #7b7474;
`

class ProviderContainer extends Component {

    handleClick = (type, data) => {
        this.props.selectItem(type,data)
    }

    handleProviderDashboardRedirect = (providerId) => {
        this.props.history.push(`/provider/dashboard/${providerId}`);
        this.props.updateLocation(`/provider/dashboard/${providerId}`);
    }

    render(){
        const { services } = this.props;
        return(
            <ContainerWrapper>
                <TitleWrapper > Service Providers </TitleWrapper>
                <GeneralCardWrapper>
                {this.props.staff.map((employee, index) => {
                    if(employee){
                        return(
                            <StaffCardContainer
                                key={`${employee.name ? employee.name.first : 'unknown'}${index}`}
                                employee={employee}
                                index={index}
                                services={services}
                                onClick={(type, data) => this.handleClick(type, data)}
                                onProviderClick={this.handleProviderDashboardRedirect}
                            />
                        )
                    }
                    else {
                        return null;
                    }
                })}
                </GeneralCardWrapper>
            </ContainerWrapper>
        )
    }
}

const mapStateToProps = ({company}) => ({
    services: company.services,
});

export default withRouter(connect(mapStateToProps,actions)(ProviderContainer));


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/ProviderContainer.jsx